/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Kirjoita jotain...',
  'fabric.editor.editorAssistiveLabel': 'Pääsisältöalue, aloita kirjoittaminen, jos haluat syöttää tekstiä.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Avaa ohjeikkuna',
};
